import React, { ReactNode } from 'react';
import { FieldRenderProps } from 'react-final-form';

type Props = FieldRenderProps<string> & {
  placeholder: string;
  fieldType?: string;
  limit?: number;
  required?: boolean;
  className?: string;
  minLength?: number;
  autoComplete?: string;
  readOnly?: boolean;
  customError?: string;
  subtext?: string;
  onChange?: () => void;
};

type State = {
};

class TextInput extends React.Component<Props, State> {
  static defaultProps = {
    fieldType: 'input',
    limit: null,
    minLength: null,
    required: false,
    className: '',
    autoComplete: 'on',
    readOnly: false,
  };

  state: State = {
  };

  render(): ReactNode {
    const htmlFor = this.props.input.name;
    return (
      <div className={`${this.props.className} text-input-group ${this.props.meta.touched && (this.props.meta.error || this.props.customError) ? 'input-error' : ''}`}>
        <input
          type={this.props.fieldType}
          className={`text-input-field ${this.props.readOnly && 'read-only'}`}
          value={this.props.input.value}
          onChange={(e) => {
            this.props.input.onChange(e);
            if (this.props.onChange) this.props.onChange();
          }}
          placeholder={this.props.placeholder}
          id={htmlFor}
          maxLength={this.props.limit}
          minLength={this.props.minLength}
          required={this.props.required}
          readOnly={this.props.readOnly}
          autoComplete={this.props.autoComplete}
        />
        <label htmlFor={htmlFor} className={`text-input-placeholder ${this.props.required && 'text-input-placeholder--mandatory'}`}>{this.props.placeholder}</label>
        {
          this.props.input.value && !this.props.readOnly && (
            <button
              className="text-input-button-container"
              onClick={() => this.props.input.onChange(null)}
              type="button"
            >
              <i className="fa fa-times" />
            </button>
          )
        }
        {
          this.props.meta.touched && (
            (this.props.customError && <span className="text-error">{this.props.customError}</span>)
            || (this.props.meta.error && <span className="text-error">{this.props.meta.error}</span>)
          )
        }
        {this.props.subtext && (
          <span className="input-subtext">{this.props.subtext}</span>
        )}
      </div>
    );
  }
}

export default TextInput;
